import React, { useState } from 'react'
import OpcionesBoton from './OpcionesBoton'
import { MDBCol, MDBRow } from 'mdbreact';
import SubirImagenesContainer from '../../../SubirImagenes';
import { Image2, Search } from 'react-iconly';
import OpcionesImagen from './OpcionesImagen';

const OpcionesBotonImagen = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [modal, setModal] = useState(false)
    const [urlImg, setUrlImg] = useState(styles?.urlImg)

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: 'urlImg' })
        setUrlImg(img.path)
        setModal(false)
    }

    return (
        <div>
            <div className='mb-2'>
                <h4>Boton</h4>
                <OpcionesBoton {...props} />
            </div>
            <OpcionesImagen {...props} />
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesBotonImagen